// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QrcodeOutlinedSvg from "@ant-design/icons-svg/es/asn/QrcodeOutlined";
import AntdIcon from '../components/AntdIcon';

var QrcodeOutlined = function QrcodeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: QrcodeOutlinedSvg
  }));
};

QrcodeOutlined.displayName = 'QrcodeOutlined';
export default React.forwardRef(QrcodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/QrcodeOutlined.js
// module id = 1651
// module chunks = 0